import state from "./state.js";
import * as getters from "./getters/index.js";
import * as mutations from "./mutations/index.js";
import * as rawActions from "./actions/index.js";
import onlyActions from "../onlyActions.js";

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions: onlyActions(rawActions),
};
